// Module
var code = "<div class=\"input-group\"> <bo-file ng-model=\"$ctrl.selectedFiles\" ignore-dirty></bo-file> <div class=\"input-group-btn\"> <button class=\"btn btn-default bo-file-upload-btn\" type=\"button\" ng-click=\"$ctrl.upload()\" ng-disabled=\"$ctrl.isUploadDisabled()\"> Upload </button> </div> </div> ";
// Exports
module.exports = code;